import type { ThemeConfig } from "../../types";

export const emojiTheme: ThemeConfig = {
  weak: { color: "#ff4d4d", label: "😢" },
  fair: { color: "#ffaa00", label: "🤔" },
  good: { color: "#2196f3", label: "😊" },
  strong: { color: "#4caf50", label: "🚀" },
};
